import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';

const RenderCustomTick = ({ x, y, payload, index, textAnchor, dataLength }) => {
    let dx = 0;
    let dy = 0;

    // For 3-axis charts (triangles)
    if (dataLength === 3) {
        if (index === 1) { // Bottom Right
            dy = 25;
            dx = -15; // Move left (towards center)
        } else if (index === 2) { // Bottom Left
            dy = 25;
            dx = 15;  // Move right (towards center)
        }
    }

    const value = payload.value;
    const parts = value.includes(' ') ? value.split(' ') : [value];

    return (
        <text
            x={x + dx}
            y={y + dy}
            textAnchor={textAnchor}
            fill="#f1f5f9"
            fontSize={14}
            fontWeight={700}
            style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.5))' }}
        >
            {parts.map((part, i) => (
                <tspan x={x + dx} dy={i === 0 ? 0 : '1.2em'} key={i}>
                    {part}
                </tspan>
            ))}
        </text>
    );
};

const ScoreRadar = ({ scores, title }) => {
    if (!scores || !scores.axes) return null;

    const translateLabel = (label) => {
        const mapping = {
            'reality_romance': '🏠 현실성',
            'Reality/Romance': '🏠 현실성',
            'reason_emotion': '🤝 역할 수용',
            'Reason/Emotion': '🤝 역할 수용',
            'consistency': '⚖️ 일관성',
            'Consistency': '⚖️ 일관성',
            'Stability': '🛡️ 안정성',
            'Empathy': '❤️ 공감 능력',
            'Force': '🔥 추진력',
            'decision_style': '🎯 결정 방식',
            'emotional_response': '🌡️ 감정 반응',
            'value_priority': '💎 가치 우선',
            'self_vs_other': '👤 자기 기준',
            'reflection': '🔍 성찰 깊이',
            'flexibility': '🌊 유연성',
            'action_initiation': '🏃 실행력',
            'perception_gap': '🧩 인식 괴리',
            'vibe': '🎭 분위기 (Vibe)',
            'identity': '🆔 정체성 (Identity)'
        };
        return mapping[label] || label;
    };

    const data = scores.axes.map(axis => ({
        subject: translateLabel(axis.label || axis.key),
        A: axis.score,
        fullMark: scores.max || 100,
    }));

    return (
        <div style={{ width: '100%', height: 450, textAlign: 'center', minHeight: '400px' }}>
            {title && (
                <div style={{ marginBottom: '1.5rem' }}>
                    <span style={{
                        color: '#60a5fa',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        letterSpacing: '0.05em'
                    }}>
                        {title}
                    </span>
                </div>
            )}
            <ResponsiveContainer width="100%" height="90%">
                <RadarChart
                    cx="50%"
                    cy="50%"
                    outerRadius="78%"
                    data={data}
                    margin={{ top: 10, right: 10, left: 10, bottom: 20 }}
                >
                    <PolarGrid stroke="#475569" strokeWidth={1} />
                    <PolarAngleAxis
                        dataKey="subject"
                        tick={<RenderCustomTick dataLength={data.length} />}
                    />
                    <PolarRadiusAxis
                        angle={30}
                        domain={[0, scores.max || 100]}
                        tick={false}
                        axisLine={false}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#0f172a',
                            border: '1px solid #334155',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                        itemStyle={{ color: '#60a5fa' }}
                    />
                    <Radar
                        name="스코어"
                        dataKey="A"
                        stroke="#60a5fa"
                        strokeWidth={3}
                        fill="#3b82f6"
                        fillOpacity={0.6}
                    />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ScoreRadar;
